export default function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-array/src/threshold/sturges.js
// module id = ../../../../d3-array/src/threshold/sturges.js
// module chunks = 4